import React from 'react'

const RejectedIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="56" height="56" rx="28" fill="#FE6461" fillOpacity="0.2" />
      <defs>
        <mask id="mask0_91_3158" x="16" y="16" width="24" height="24">
          <rect x="16" y="16" width="24" height="24" fill="#C4C4C4" />
        </mask>
      </defs>
      <path
        d="M28.0008 29.4L23.1008 34.3C22.9174 34.4833 22.6841 34.575 22.4008 34.575C22.1174 34.575 21.8841 34.4833 21.7008 34.3C21.5174 34.1167 21.4258 33.8833 21.4258 33.6C21.4258 33.3167 21.5174 33.0833 21.7008 32.9L26.6008 28L21.7008 23.1C21.5174 22.9167 21.4258 22.6833 21.4258 22.4C21.4258 22.1167 21.5174 21.8833 21.7008 21.7C21.8841 21.5167 22.1174 21.425 22.4008 21.425C22.6841 21.425 22.9174 21.5167 23.1008 21.7L28.0008 26.6L32.9008 21.7C33.0841 21.5167 33.3174 21.425 33.6008 21.425C33.8841 21.425 34.1174 21.5167 34.3008 21.7C34.4841 21.8833 34.5758 22.1167 34.5758 22.4C34.5758 22.6833 34.4841 22.9167 34.3008 23.1L29.4008 28L34.3008 32.9C34.4841 33.0833 34.5758 33.3167 34.5758 33.6C34.5758 33.8833 34.4841 34.1167 34.3008 34.3C34.1174 34.4833 33.8841 34.575 33.6008 34.575C33.3174 34.575 33.0841 34.4833 32.9008 34.3L28.0008 29.4Z"
        fill="#FE6461"
      />
    </svg>
  )
}

export default RejectedIcon
